import { Navigate, Route, Routes } from 'react-router-dom';
import { ConfirmProvider } from './lib/confirm.tsx';
import { AdminAcceptInvite } from './auth/AdminAcceptInvite.tsx';
import { AdminLogin } from './auth/AdminLogin.tsx';
import { SsoCallback } from './auth/SsoCallback.tsx';
import { AdminSignedOut } from './auth/AdminSignedOut.tsx';
import { AdminNoAccess } from './auth/AdminNoAccess.tsx';
import { CompanyLogin } from './auth/CompanyLogin.tsx';
import { CompanyLinkRedeem } from './auth/CompanyLinkRedeem.tsx';
import { CompanyCallback } from './auth/CompanyCallback.tsx';
import { CompanyExpired } from './auth/CompanyExpired.tsx';
import { DriverLanding } from './auth/DriverLanding.tsx';
import { DriverCallback } from './auth/DriverCallback.tsx';
import { NotFound } from './auth/NotFound.tsx';
import { AdminShell } from './admin/AdminShell.tsx';
import { AdminDashboard } from './admin/Dashboard.tsx';
import { AdminCompanies } from './admin/Companies.tsx';
import { AdminCompanyDetail } from './admin/CompanyDetail.tsx';
import { AdminQuestionBuilder } from './admin/QuestionBuilder.tsx';
import { AdminQuestionnaires } from './admin/Questionnaires.tsx';
import { AdminDocuments } from './admin/Documents.tsx';
import { AdminExpiringDocuments } from './admin/ExpiringDocuments.tsx';
import { AdminSettings } from './admin/Settings.tsx';
import { CompanyShell } from './company/CompanyShell.tsx';
import { CompanyHome } from './company/Home.tsx';
import { CompanyInformation } from './company/CompanyInfo.tsx';
import { CompanyDrivers } from './company/Drivers.tsx';
import { Questionnaire } from './company/Questionnaire.tsx';
import { MyDocuments } from './company/MyDocuments.tsx';
import { DriverShell } from './driver/DriverShell.tsx';
import { DriverQuestionnaire } from './driver/DriverQuestionnaire.tsx';

export function App() {
  return (
    <ConfirmProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />

        {/* Auth */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/sso/callback" element={<SsoCallback />} />
        {/* Must stay OUTSIDE the AdminShell route: its !user guard redirects to
            /admin/login, which auto-starts SSO and would undo the sign-out. */}
        <Route path="/admin/signed-out" element={<AdminSignedOut />} />
        {/* Must stay OUTSIDE the AdminShell route for the same reason as
            /admin/signed-out: the shell's !user guard redirects to
            /admin/login, which auto-starts SSO and would bounce a refused user
            straight back here in a loop. */}
        <Route path="/admin/no-access" element={<AdminNoAccess />} />
        <Route path="/admin/accept-invite" element={<AdminAcceptInvite />} />
        <Route path="/c/login" element={<CompanyLogin />} />
        <Route path="/c/expired" element={<CompanyExpired />} />
        <Route path="/c/callback" element={<CompanyCallback />} />
        <Route path="/c/:token" element={<CompanyLinkRedeem />} />
        <Route path="/d/:token" element={<DriverLanding />} />
        <Route path="/d/callback" element={<DriverCallback />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<AdminDashboard />} />
          <Route path="companies" element={<AdminCompanies />} />
          <Route path="companies/:id" element={<AdminCompanyDetail />} />
          <Route path="questionnaires" element={<AdminQuestionnaires />} />
          <Route path="questions" element={<AdminQuestionBuilder />} />
          <Route path="documents" element={<AdminDocuments />} />
          <Route path="expiring-documents" element={<AdminExpiringDocuments />} />
          <Route path="users" element={<Navigate to="/admin/settings?tab=users" replace />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="activity" element={<Navigate to="/admin/settings?tab=activity" replace />} />
        </Route>

        {/* Company */}
        <Route path="/c" element={<CompanyShell />}>
          <Route index element={<CompanyHome />} />
          <Route path="info" element={<CompanyInformation />} />
          <Route path="questionnaire" element={<Questionnaire />} />
          <Route path="drivers" element={<CompanyDrivers />} />
          <Route path="documents" element={<MyDocuments />} />
        </Route>

        {/* Driver */}
        <Route path="/d" element={<DriverShell />}>
          <Route index element={<Navigate to="/d/questionnaire" replace />} />
          <Route path="questionnaire" element={<DriverQuestionnaire />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </ConfirmProvider>
  );
}
